import breakpoints from "../../../../assets/images/docs/breakpoints.png";
import * as React from 'react';
export default {
  breakpoints,
  React
};